import Vue from 'vue';
import Router from 'vue-router';
import { store } from '@/_store';

import AdminLoginPage from '@/views/AdminLoginPage';
import AdminPage from '@/views/AdminPage';
import ClientLoginPage from '@/views/ClientLoginPage';
import ClientDashboard from '@/views/ClientDashboard';
import HolidaysCalendar from '@/views/HolidaysCalendar';
import AuthError from '@/views/AuthError';

Vue.use(Router);

const routes = [
  {
    path: '/admin',
    component: AdminPage,
  },
  {
    path: '/admin-login',
    component: AdminLoginPage,
  },
  {
    path: '/login',
    component: ClientLoginPage,
  },
  {
    path: '/holidays',
    component: HolidaysCalendar,
  },
  {
    name: 'AuthError',
    path: '/auth-error',
    component: AuthError,
  },
  {
    path: '/',
    component: ClientDashboard,
  },
  { path: '*', redirect: '/' },
];

export const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/' : '/',
  routes: routes,
});

const basicClasses = 'dashboard db-';

function setBodyClasses(to) {
  document.body.classList = [];
  basicClasses.split(' ').map(e => document.body.classList.add(e));
  if (to.meta && to.meta.bodyClass) {
    to.meta.bodyClass.split(' ').map(e => document.body.classList.add(e));
  }
}

router.beforeEach((to, from, next) => {
  setBodyClasses(to);
  // redirect to login page if not logged in and trying to access a restricted page
  const userData = store.state.authentication.user;
  // console.log('to,userData',to,userData);
  const publicPages = ['/login','/admin-login', '/auth-error'];
  const authRequired = publicPages.reduce((a,e)=>{return !a ? a : to.path.indexOf(e)===0 ? false : true;},true);

  if (authRequired && !userData) {
    if (to.path==='/') {
      return next('/login');
    } else {
      return next('/admin-login');
    }
  }

  if (to.path==='/' && userData.isAdmin) {
    return next('/admin');
  }

  next();
});
